import * as moment from 'moment';
import {IHide} from '../showLess/IHide';

export class ReminderItem implements IHide {

  title: string;
  subtitle: string;
  description: string;
  actionLink: string;
  icon: string;
  accessibility: string;
  analyticsName: string;
  expiryDate: Date;
  dismissId: string;
  status: string;
  order: number;
  hide: boolean;

  static formatDate (date) {
    return  moment(date).format('MMM Do YYYY');
  }

  static formatDateForId (date) {
    return  moment(date).format('YYYY_MM_DD');
  }
}



// WEBPACK FOOTER //
// ./app/reminder/dataObject/ReminderItem.ts